import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpService } from '../../services/http-service.service';
import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import * as moment from 'moment';
import Quill from 'quill';
import BlotFormatter from 'quill-blot-formatter';
import { NavBarItem, PncReport } from '../../model';
Quill.register('modules/blotFormatter', BlotFormatter);
import { LogService } from 'src/app/services';

@Component({
  selector: 'pnc-report',
  templateUrl: './pnc-report.component.html',
  styleUrls: ['./pnc-report.component.scss']
})

export class PncReportComponent implements OnInit {
  @ViewChild('reportForm', {static: true}) reportForm:ViewContainerRef;
  pncReport = PncReport.createNewIbisWithData();
  loading: boolean = false;
  today: Date = new Date();
  quillModules = {
    blotFormatter: {},
    toolbar: [
      [{ 'align': null}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      ['link', 'image'],
      ['clean'],
    ]
  };
  navBarItems: NavBarItem[] = [
    {NAME: 'Data', SELECTED: false, TARGET: 'BASIC_INFO'},
    {NAME: 'Executive Summary', SELECTED: false, TARGET: 'EXECUTIVE_SUMMARY'},
    {NAME: 'Summary Table', SELECTED: false, TARGET: 'SUMMARY_TABLE'},
    {NAME: 'GDP Description', SELECTED: false, TARGET: 'GDP_DESCRIPTION'},
    {NAME: 'GDP Key Points', SELECTED: false, TARGET: 'GDP_KEY_POINTS'},
  ];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public httpService: HttpService,
    private scrollToService: ScrollToService,
    private logService : LogService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      if(params.id){
        this.pncReport.ID = params.id;
        this.getPncReport();
      }
    });
  }

  /** Go back to the ibis report list page */
  goBack(): void{
    this.router.navigate(['/manage/research/pnc']);
  }

  /** Save ibis report */
  saveReport(): void{
    if(this.pncReport.ID){
      this.httpService.updatePncReport(this.pncReport)
        .subscribe((resp) => {
          if(resp.success){
            this.goBack();
          }this.logService.log(resp);
        }, (error) => {
          this.logService.log(error);
        });
    }else{
      this.httpService.createPncReport(this.pncReport)
        .subscribe((resp) => {
          if(resp.success){
            this.goBack();
          }this.logService.log(resp);
        }, (error) => {
          this.logService.log(error);
        });
    }
  }

  /** Scroll to the particular item when item clicked */
  onSelect(item: NavBarItem): void {
    this.navBarItems.map(i => i.SELECTED = false);
    item.SELECTED = true;
    this.scrollTo(item.TARGET);
  }

  /** Scroll to target element */
  scrollTo(target: string): void {
    const config: ScrollToConfigOptions = { target };
    this.scrollToService.scrollTo(config);
  }

  /** Open calender in month view mode */
  onOpenCalendar(container): void {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode('month');
  }

  /** Format date when date selected */
  formatDate(): void{
    this.pncReport.DATE = moment(this.pncReport.DATE).format('MM-YYYY');
  }

  // trackByFn() - For tracking an array item.
  trackByFn(index: any): void {
    return index;
  }

  /** Get Pnc Report */
  getPncReport(): void{
    this.httpService.getPncReportById(this.pncReport.ID)
      .subscribe((resp) => {
        if(resp.success){
          this.pncReport = JSON.parse(JSON.stringify(resp.result));
        }else this.logService.log(resp);
      }, (error) => {
        this.logService.log(error);
      });
  }
}
